import gql from 'graphql-tag';

import { QUESTION_DETAILS_FRAGMENT } from '../fragments/Question/questionDetails';

export const GET_QUESTION_DETAILS_QUERY = gql`
  query GetQuestionDetails($questionId: String!) {
    loggedIn {
      questionById(id: $questionId) {
        ...questionDetails
      }
    }
  }

  ${QUESTION_DETAILS_FRAGMENT}
`;

export { useGetQuestionDetailsQuery } from '../gen/types';
